import { version } from '../../version';

export const environment = {
  production: true,
  hmr: false,
  version: version
};
